import axios from 'axios';
import qs from 'qs';
import util from './util';
import { store } from './store/index';
import userServ from './services/user.service';

const baseURLForRetailer = `${process.env.VUE_APP_API_BASE_URL}/retailer`;
const baseURLForRetailerGroup = `${process.env.VUE_APP_API_BASE_URL}/g`;

function Request(baseURL) {

    const instance = axios.create({
        baseURL,
        transformResponse: [].concat(
            function(data) {
                //過濾"&amp;"
                //ex: AT&amp;
                return data.replace(/&amp;/g, '&');
            },
            axios.defaults.transformResponse
        )
    });

    instance.interceptors.response.use(function(response) {
        // Any status code that lie within the range of 2xx cause this function to trigger
        // Do something with response data
        if (response.data && response.data.message) {
            store.dispatch('message/success', { title: 'Success', content: response.data.message }, { root: true }, 2000);
        }

        return response;
    }, function(error) {
        // Any status codes that falls outside the range of 2xx cause this function to trigger
        // Do something with response error

        if (
            error.response &&
            error.response.status < 500 &&
            error.response.data &&
            (error.response.data.error || error.response.data.errors)
        ) {
            const errorMessages = typeof error.response.data.error == 'string' ?
                error.response.data.error :
                Object.values(error.response.data.errors).join(', ');
            store.dispatch('message/warning', { title: 'Warning', content: errorMessages }, { root: true }, 10000);
        } else if (error.response && error.response.status && error.response.status === 401) {
            //store.dispatch('message/warning', { title: 'Unauthorized Request', content: 'You have no authority to access this resource or your session has been expired, please try to login again.' }, { root: true });
            store.dispatch('auth/logout');
        } else {
            store.dispatch('message/error', { title: 'Exceptional Error', content: 'Please retry after mins or contact with Aerobile' }, { root: true });
        }

        return Promise.reject(error);
    });

    const token = userServ.getToken();

    if (token) {
        instance.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    }

    return instance;

}

function RequestWithIdentity() {
    const isRetailerGroup = userServ.isRetailerGroup();

    return new Request(isRetailerGroup ? baseURLForRetailerGroup : baseURLForRetailer);
}

function login(email, password, recaptcha_token, isRetailer) {
    return new Request(isRetailer ? baseURLForRetailer : baseURLForRetailerGroup)
        .post(
            '/auth/login',
            qs.stringify({ email, password, recaptcha_token })
        );
}

function logout() {
    return new RequestWithIdentity().post('/auth/logout')
}

function getCarriers() {
    return new RequestWithIdentity().get(
        '/carrier',
    )
}

function getPlans() {
    return new RequestWithIdentity().get(
        '/plan',
    )
}

function getRetailersTags() {
    return new RequestWithIdentity().get(
        '/retailers-tag',
    )
}

function getSimcards(status, carrier_id, from, to, type, text) {

    const params = {
        act_status: status,
        carrier_id,
        from: from ? util.dateToYMD(from) : null,
        to: to ? util.dateToYMD(to) : null,
        type,
        text,
    };

    return new RequestWithIdentity().get(
        '/simcard', { params }
    ).then(function(res) {
        res.data.data = res.data.data.map(simcard => {
            simcard.activated_date = simcard.activated_date ?
                new Date(simcard.activated_date) :
                null;
            return simcard;
        });
        return res;
    })
}

function getReport(status, carrier_id, from, to) {

    const params = {
        act_status: status,
        carrier_id,
        from: from ? util.dateToYMD(from) : null,
        to: to ? util.dateToYMD(to) : null,
    };

    return new RequestWithIdentity().get(
        '/retailer-report', { params }
    )

}

function createTag(tagName) {
    return new RequestWithIdentity().post(
        '/retailers-tag',
        qs.stringify({ tag_name: tagName })
    )
}

function updateTag(tag) {
    return new RequestWithIdentity().put(
        `/retailers-tag/${tag.id}`,
        qs.stringify({ tag_name: tag.name })
    )
}

function removeTag(tag) {
    return new RequestWithIdentity().delete(`/retailers-tag/${tag.id}`)
}

function assignTagToSimcards(tagId, simcardNos) {
    return new RequestWithIdentity().post(
        '/simcard/retailers-tag',
        qs.stringify({
            tag_id: tagId,
            simcard_nos: simcardNos,
        })
    )
}

function changePassword(originalPassword, newPassword) {
    return new RequestWithIdentity().post(
        '/password',
        qs.stringify({
            original_password: originalPassword,
            new_password: newPassword,
        })
    )
}

function activateSimcards(simcards) {
    return new RequestWithIdentity().post(
        '/simcard/activate',
        qs.stringify({
            simcards,
        })
    )
}

export default {
    login,
    getCarriers,
    getPlans,
    getSimcards,
    getReport,
    getRetailersTags,
    createTag,
    updateTag,
    removeTag,
    assignTagToSimcards,
    changePassword,
    logout,
    activateSimcards,
}